import React, { useEffect, useState } from 'react';
import { Translation, getI18n } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { Typography } from 'antd';
import notification from '../../../elements/lib/NotificationWrapper';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';
import LearningAdminModuleCard from '../containers/LearningAdminModuleCardContainer';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const confirmTexts = {
  title: getI18n().t('learning_admin_module_action_delete_title'),
  description: null,
  leaveText: getI18n().t('learning_admin_module_action_delete_leave'),
  saveText: getI18n().t('learning_admin_module_action_delete_save'),
};

const LearningAdminModulesGridList = ({
  moduleSerieId,
  partnershipId,
  load,
  patch,
  value,
  defaultLimit,
  defaultOrder,
  defaultScope,
  moduleSerieTitle,
  remove,
  view,
  activeKey,
  trackerActions,
  ...props
}) => {
  const [modules, setModules] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [moduleIdDelete, setModuleIdDelete] = useState(null);

  useEffect(() => {
    load(
      partnershipId,
      moduleSerieId,
      {},
      1,
      defaultLimit,
      defaultOrder,
      defaultScope,
      (success, result) => {
        if (success) {
          setModules(result);
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnershipId, moduleSerieId, load]);

  const handleDelete = (id) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_DELETE_MODULE
    );
    remove(partnershipId, id, (success) => {
      if (success) {
        load(
          partnershipId,
          moduleSerieId,
          {},
          1,
          defaultLimit,
          defaultOrder,
          defaultScope,
          (success, result) => {
            if (success) {
              setModules(result);
            }
          }
        );
        notification.success(getI18n().t('feedback_delete_success'));
      } else {
        notification.error(getI18n().t('feedback_delete_error'));
      }
    });
  };

  const handleValue = (id, value) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_TOGGLE_STATUS_MODULE
    );
    patch(partnershipId, id, { public_status: value }, (success) => {
      if (success) {
        setModules((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, public_status: value } : item
          )
        );
        notification.success(getI18n().t('feedback_update_success'));
      } else {
        notification.error(getI18n().t('feedback_update_error'));
      }
    });
  };

  const handleOpenConfirmationModal = (id) => {
    setConfirmationModalOpen(true);
    setModuleIdDelete(id);
  };

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
    setModuleIdDelete(null);
  };

  const handleConfirmDelete = () => {
    setConfirmationModalOpen(false);
    handleDelete(moduleIdDelete);
    setModuleIdDelete(null);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      trackerActions(
        mixpanelEventsEnum.ACTIONS_PARTNER.LEARNINGS_ADMIN_REORDER_MODULE
      );
      const oldIndex = modules.findIndex((module) => module.id === active.id);
      const newIndex = modules.findIndex((module) => module.id === over.id);

      const items = Array.from(modules);
      const [reorderedItem] = items.splice(oldIndex, 1);
      items.splice(newIndex, 0, reorderedItem);

      setModules(items);

      patch(partnershipId, active.id, { order: newIndex + 1 }, (success) => {
        if (!success) {
          const revertedItems = Array.from(modules);
          const [revertedItem] = revertedItems.splice(newIndex, 1);
          revertedItems.splice(oldIndex, 0, revertedItem);
          setModules(revertedItems);
        }
      });
    }
  };

  return (
    <Translation>
      {(t) => (
        <>
          {modules.length > 0 && (
            <>
              <div className='module-serie-module-card'>
                <Title level={4}>{moduleSerieTitle}</Title>
                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={modules.map((module) => module.id)}
                    strategy={rectSortingStrategy}
                  >
                    <div className='module-serie-module-card-container'>
                      {modules.map((module) => (
                        <LearningAdminModuleCard
                          key={module.id}
                          item={module}
                          handleValue={handleValue}
                          handleOpenConfirmationModal={
                            handleOpenConfirmationModal
                          }
                          view={view}
                          activeKey={activeKey}
                        />
                      ))}
                    </div>
                  </SortableContext>
                </DndContext>
              </div>

              <ConfirmationModal
                texts={confirmTexts}
                openConfirmationModal={confirmationModalOpen}
                onLeaveConfirmation={handleConfirmDelete}
                onSaveConfirmation={handleConfirmLeave}
                onCancel={handleConfirmLeave}
                setConfirmationModalOpen={setConfirmationModalOpen}
              />
            </>
          )}
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModulesGridList);

Logger.log('silly', `LearningAdminModulesGridList loaded.`);
